import { render, staticRenderFns } from "./preference.vue?vue&type=template&id=362f9ef0&scoped=true&"
import script from "./preference.vue?vue&type=script&lang=js&"
export * from "./preference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362f9ef0",
  null
  
)

component.options.__file = "preference.vue"
export default component.exports